/* Actions */
export const SET_LANGUAGE = "setLanguage";

/* URLs */
export const LOGIN_AUTH2_URL = "https://zilumbbkac.execute-api.eu-west-1.amazonaws.com/auth/auth.s2/InvoxAPI";
export const REFRESH_URL = "https://zilumbbkac.execute-api.eu-west-1.amazonaws.com/auth/refresh/InvoxAPI";
export const OLD_LOGIN_URL = "https://go.invoxcontact.io/webagent/";

export const DOMAIN_TYPE = {
  numintec: "Numintec",
  generali: "Generali",
};

/* Constants */
export const LANGUAGE = "language";

/* Authorization Server */
export const AUTH_SERVER_URL = "https://auth.invoxcontact.com";
export const AUTHORIZATION_ENDPOINT = "/protocol/openid-connect/auth";
export const CODE_AUTH_URL = "https://apiv2.invoxcontact.com/auth/code.s1/InvoxAPI";
export const GENERALI_CODE_AUTH_URL = "https://apis.generali.invoxcontact.com/auth/code.s1/InvoxAPI";
